// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__r3i4X"};